var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 d-flex justify-space-between",staticStyle:{"font-size":"26px"}},[_c('div',[_vm._v("รวมทั้งหมด "),_c('b',[_vm._v(_vm._s(_vm.$props.total))]),_vm._v(" รายการ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }